import ErrorModal from './ErrorModal';
import { IErrorModal, IErrorModalProps } from './types/errorModal';

export default ErrorModal;
export { type IErrorModal, type IErrorModalProps };
